export const integrations = {
  title: 'Integraciones',
  subtitle: 'Conectá tus herramientas y servicios para potenciar tu flujo de trabajo.',

  categories: {
    cms: 'CMS',
    analytics: 'Google y analítica',
    social: 'Redes sociales',
  },

  providers: {
    webflow: {
      name: 'Webflow',
      description: 'Publicá artículos directo en tu CMS de Webflow.',
    },
    wordpress: {
      name: 'WordPress',
      description: 'Publicá posts, páginas y assets de landings en tu sitio WordPress.',
    },
    wordpress_com: {
      name: 'WordPress.com',
      description: 'Publicá posts en tu sitio de WordPress.com (próximamente).',
    },
    google_search_console: {
      name: 'Google Search Console',
      description: 'Conectá tu Search Console para analizar rendimiento de búsqueda e indexación.',
    },
    google_analytics_4: {
      name: 'Google Analytics 4',
      description: 'Conectá GA4 para medir el tráfico que llega desde asistentes y buscadores con IA.',
    },
    framer: {
      name: 'Framer',
      description: 'Publicá contenido directo en tus colecciones CMS de Framer.',
    },
    tiendanube: {
      name: 'Tiendanube',
      description: 'Publicá artículos de blog directo en tu tienda de Tiendanube / Nuvemshop.',
    },
  },

  status: {
    connected: 'Conectado',
    expired: 'Expirado — reconectar',
    revoked: 'Revocado — reconectar',
    error: 'Error',
    pendingSiteSelection: 'Seleccioná un sitio',
    notConnected: 'No conectado',
    comingSoon: 'Próximamente',
  },

  actions: {
    connect: 'Conectar',
    connecting: 'Redirigiendo…',
    disconnect: 'Desconectar',
    disconnecting: 'Desconectando…',
    reconnect: 'Reconectar',
    selectSite: 'Seleccionar sitio',
    selectProperty: 'Seleccionar propiedad',
    selectCollection: 'Seleccionar colección',
  },

  siteLabel: 'Sitio',
  connectedAtLabel: 'Conectado el',
  tiendanubeStoreLabel: 'Tienda {{storeId}}',

  permissions: {
    adminOnly: 'Solo los owners y admins de la organización pueden gestionar integraciones.',
  },

  siteSelectionDialog: {
    title: 'Seleccioná un sitio',
    description: 'Tu cuenta de Google Search Console tiene varias propiedades. Elegí cuál querés conectar.',
    confirm: 'Conectar sitio',
    cancel: 'Cancelar',
    searchPlaceholder: 'Buscar propiedades...',
    noResults: 'Ninguna propiedad coincide con tu búsqueda.',
    domainProperty: 'Propiedad de dominio',
    urlProperty: 'Propiedad de URL',
  },

  ga4PropertySelectionDialog: {
    title: 'Seleccioná una propiedad GA4',
    description: 'Tu cuenta de Google tiene acceso a varias propiedades de Analytics. Elegí cuál tiene que leer Sergeo.',
    confirm: 'Conectar propiedad',
    cancel: 'Cancelar',
    searchPlaceholder: 'Buscar propiedades...',
    noResults: 'Ninguna propiedad coincide con tu búsqueda.',
    propertyIdLabel: 'ID {{id}}',
  },

  framerConnectDialog: {
    title: 'Conectar Framer',
    description:
      'Pegá tu API key de Framer y la URL del proyecto. Podés encontrar la API key en la configuración de tu cuenta de Framer.',
    apiKeyLabel: 'API key',
    apiKeyPlaceholder: 'Pegá tu API key de Framer',
    projectUrlLabel: 'URL del proyecto',
    projectUrlPlaceholder: 'https://framer.com/projects/Sites--xxxx',
    connect: 'Conectar',
    connecting: 'Conectando…',
    cancel: 'Cancelar',
    showApiKey: 'Mostrar API key',
    hideApiKey: 'Ocultar API key',
    validation: {
      apiKeyRequired: 'La API key es obligatoria.',
      projectUrlInvalid: 'Tiene que ser una URL de proyecto de Framer (https://framer.com/projects/...).',
    },
    errors: {
      invalidApiKey: 'La API key es inválida o expiró. Revisala y volvé a intentar.',
      invalidProjectUrl: 'No pudimos acceder a ese proyecto de Framer. Verificá que la URL sea correcta.',
      noCollections: 'Este proyecto de Framer todavía no tiene colecciones CMS.',
      connectFailed: 'No pudimos conectar con Framer. Intentá de nuevo en un momento.',
      alreadyConnected: 'Este proyecto de Framer ya está conectado.',
      generic: 'Algo salió mal. Intentá de nuevo.',
    },
  },

  webflowConnectDialog: {
    title: 'Conectar Webflow',
    description:
      'Conectá tu sitio de Webflow usando un Site API token. Funciona con acceso de admin del sitio — no requiere admin del workspace.',
    apiTokenLabel: 'Site API token',
    apiTokenPlaceholder: 'Pegá tu Site API token de Webflow',
    helpText:
      'Generá el token en Webflow desde Site settings → Apps & integrations → API access, con los scopes CMS y Sites en lectura y escritura.',
    connect: 'Conectar',
    connecting: 'Conectando…',
    cancel: 'Cancelar',
    showApiToken: 'Mostrar API token',
    hideApiToken: 'Ocultar API token',
    useOAuthInstead: '¿Preferís iniciar sesión con Webflow? Conectar vía OAuth',
    validation: {
      apiTokenRequired: 'El API token es obligatorio.',
    },
    errors: {
      invalidToken:
        'No pudimos leer el sitio y sus colecciones del CMS con este token. Verificá que sea válido y que lo hayas creado con acceso a CMS y Sites.',
      multipleSites:
        'Este token tiene acceso a varios sitios. Generá un Site API token desde la configuración del sitio.',
      noSites: 'Este token no tiene ningún sitio disponible. Verificá que lo generaste en el sitio correcto.',
      alreadyConnected: 'Ya hay un sitio de Webflow conectado para esta organización.',
      generic: 'Algo salió mal. Volvé a intentar.',
    },
  },

  wordpressConnectDialog: {
    title: 'Conectar WordPress',
    description:
      'Conectá un sitio WordPress self-hosted usando una application password. El sitio debe exponer la REST API de WordPress por HTTPS.',
    siteUrlLabel: 'URL del sitio',
    siteUrlPlaceholder: 'https://example.com',
    usernameLabel: 'Usuario',
    usernamePlaceholder: 'Usuario de WordPress',
    applicationPasswordLabel: 'Application password',
    applicationPasswordPlaceholder: 'Pegá tu application password de WordPress',
    helpText:
      'Creá una application password en WordPress desde Usuarios → Perfil → Application Passwords.',
    connect: 'Conectar',
    connecting: 'Conectando…',
    cancel: 'Cancelar',
    showApplicationPassword: 'Mostrar application password',
    hideApplicationPassword: 'Ocultar application password',
    validation: {
      siteUrlInvalid: 'Ingresá una URL válida de WordPress.',
      siteUrlHttps: 'La URL de WordPress debe usar HTTPS.',
      usernameRequired: 'El usuario es obligatorio.',
      applicationPasswordRequired: 'La application password es obligatoria.',
    },
    errors: {
      invalidSiteUrl: 'Ingresá una URL HTTPS válida de WordPress.',
      restUnavailable: 'No pudimos acceder a la REST API de WordPress en este sitio.',
      invalidCredentials: 'El usuario o la application password son inválidos.',
      routesUnavailable:
        'Este sitio no expone las rutas REST requeridas para posts, páginas y media.',
      alreadyConnected: 'Este sitio WordPress ya está conectado.',
      generic: 'Algo salió mal. Intentá de nuevo.',
    },
  },

  tiendanubeConnectDialog: {
    title: 'Conectar Tiendanube',
    description:
      'Conectá tu tienda de Tiendanube / Nuvemshop usando el ID de la tienda y un access token.',
    storeIdLabel: 'ID de la tienda',
    storeIdPlaceholder: '123456',
    accessTokenLabel: 'Access token',
    accessTokenPlaceholder: 'Pegá tu access token de Tiendanube',
    authorNameLabel: 'Nombre de autor (opcional)',
    authorNamePlaceholder: 'Ej: el nombre de tu marca',
    authorNameHint:
      'Se muestra públicamente como la firma del autor en los artículos publicados en tu tienda.',
    helpText:
      'Encontrá el ID de tu tienda y generá un access token desde el admin de Tiendanube en Aplicaciones → Desarrollar tu propia app.',
    connect: 'Conectar',
    connecting: 'Conectando…',
    cancel: 'Cancelar',
    showAccessToken: 'Mostrar access token',
    hideAccessToken: 'Ocultar access token',
    validation: {
      storeIdRequired: 'El ID de la tienda es obligatorio.',
      storeIdNumeric: 'El ID de la tienda solo puede tener números.',
      accessTokenRequired: 'El access token es obligatorio.',
      authorNameTooLong: 'El nombre de autor no puede superar los 80 caracteres.',
    },
    errors: {
      apiUnavailable: 'No pudimos acceder a la API de Tiendanube para esta tienda.',
      invalidCredentials: 'El ID de la tienda o el access token son inválidos.',
      alreadyConnected: 'Esta tienda de Tiendanube ya está conectada.',
      generic: 'Algo salió mal. Intentá de nuevo.',
    },
  },

  framerCollectionDialog: {
    title: 'Seleccioná una colección',
    description:
      'Elegí la colección CMS de Framer donde Sergeo va a publicar el contenido.',
    confirm: 'Conectar colección',
    cancel: 'Cancelar',
    searchPlaceholder: 'Buscar colecciones...',
    noResults: 'Ninguna colección coincide con tu búsqueda.',
    emptyCollections:
      'No hay colecciones CMS en este proyecto. Agregá una colección en Framer y volvé a intentarlo.',
    readOnly: 'Solo lectura',
    managedBy: 'Gestionada por {{manager}}',
    slugField: 'Slug: {{field}}',
    noSlugField: 'Sin campo slug configurado',
  },

  toast: {
    connected: 'Integración conectada con éxito.',
    disconnected: 'Integración desconectada.',
    connectFailed: 'No pudimos iniciar el flujo de conexión. Intentá de nuevo.',
    disconnectFailed: 'No pudimos desconectar la integración. Intentá de nuevo.',
    connectionError: 'La conexión no pudo completarse: {{error}}',
    siteSelectionFailed: 'No pudimos seleccionar el sitio. Intentá de nuevo.',
    propertySelectionFailed: 'No pudimos seleccionar la propiedad. Intentá de nuevo.',
    framerConnectFailed: 'No pudimos conectar Framer. Revisá tu API key y la URL del proyecto.',
    wordpressConnectFailed: 'No pudimos conectar WordPress. Revisá el sitio y las credenciales.',
    tiendanubeConnectFailed:
      'No pudimos conectar Tiendanube. Revisá el ID de la tienda y el access token.',
    collectionSelectionFailed: 'No pudimos seleccionar la colección. Intentá de nuevo.',
  },

  disconnectDialog: {
    title: '¿Desconectar {{provider}}?',
    description:
      'Sergeo va a perder acceso a publicar en este proveedor. Podés reconectar cuando quieras.',
    confirm: 'Desconectar',
    cancel: 'Cancelar',
  },

  empty: {
    title: 'No hay integraciones disponibles',
    subtitle: 'Las integraciones aparecerán acá cuando estén disponibles en tu plan.',
  },

  errorState: {
    title: 'Algo salió mal',
    subtitle: 'No pudimos cargar tus integraciones. Intentá de nuevo.',
    retry: 'Reintentar',
  },

  publishShortcut: {
    label: 'Publicar con Sergeo',
    labelWithProvider: 'Publicar en {{provider}} con Sergeo',
    prefillMessage: 'Publicá el contenido «{{contentTitle}}»{{siteSuffix}} en {{providerName}}. referentContentId={{contentId}}',
    ariaLabel: 'Publicar en {{provider}} con Sergeo',
  },
}
